import { BaseService } from "mrb/core";
import LoadioGenreApiRouteService from "./LoadioGenreApiRouteService";

class LoadioGenreService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new LoadioGenreApiRouteService());
    }

    find(filter, abortSignal = null) {
        const url = this.routeService.find(filter);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default LoadioGenreService;
